// extracted by mini-css-extract-plugin
export default {"wrapper":"ptb27H","title":"SUweCR","items":"eU4bqO","item":"_lMkVw","role":"BXjQ4x","name":"Jd0quk","crew":"Y2FMCA","cast":"l39jZ1"};